// Vuex
// import store from '@/store.js';
// i18n
// import i18n from '@/i18n';
// Self-made Snackbar
// import snackbar from '@/plugins/snackbar';
// import consts from "@/consts.js";

import Request from './request';

async function fetch(data) {
    return Request('get', "api/summary-monthly-statement/index", data);
}

async function fetchOne(id) {
    return Request('get', "api/summary-monthly-statement/view/" + id);
}

async function dailyStatement(data) {
    return Request('get', "api/summary-monthly-statement/daily-statement", data);
}

async function dailyStatementView(data) {
    return Request('get', "api/summary-monthly-statement/daily-statement-view", data);
}

async function dailyStatementBillView(data) {
    return Request('get', "api/summary-monthly-statement/daily-statement-bill-view", data);
}

async function reCreate(data) {
    return Request('post', "api/summary-monthly-statement/re-create", data);
}

async function finishOne(data) {
    return Request('post', "api/summary-monthly-statement/finish", data);
}

export default {
    fetch,
    fetchOne,
    dailyStatement,
    dailyStatementView,
    dailyStatementBillView,
    reCreate,
    finishOne,
};